<template>
  <default>
    <div class="tw-w-full" id="myDiv">
      <bread-crumb :breadcrumbs="breadcrumbs" />

      <transition
          name="fade"
          mode="out-in"
          appear
          :duration="500"
      >
        <keep-alive>
          <component
              v-bind:is="current"
              @to-car-details="toCarDetails"
              @to-cover-summary="toCoverSummary"
              @to-branch-selection="toBranchSelection"
              @to-payment-selection="toPaymentSelection"
              @to-make-payment="toMakePayment"
              v-bind="data"
          ></component>
        </keep-alive>
      </transition>

    </div>
  </default>
</template>

<script>
import Default from '@/components/layout/Default';
import BreadCrumb from '@/components/dashboard/BreadCrumb';
import PersonalDetails from '@/components/buy/PersonalDetails';
import VehicleDetails from '@/components/buy/VehicleDetails';
import CoverSummary from '@/components/buy/CoverSummary';
import BranchSelections from '@/components/buy/BranchSelections';
import PaymentSelection from '@/components/buy/PaymentSelection';
import MakePayment from '@/components/buy/MakePayment';
import { mapGetters } from 'vuex';
import PersonalDetailsHealth from '@/components/buy/health/PersonalDetailsHealth';
import PersonalDetailsDP from '@/components/buy/dp/PersonalDetailsDP';
import DPRenewal from '@/components/buy/dp/DPRenewal';

export default {
  name: 'BuyCover',
  components: {
    BreadCrumb, Default, PersonalDetails, VehicleDetails, CoverSummary, BranchSelections, PaymentSelection, MakePayment, PersonalDetailsHealth, PersonalDetailsDP, DPRenewal,
  },
  data: (vm) => ({
    breadcrumbs: [
      {
        text: 'Buy Cover',
        disabled: true,
        to: { name: 'BuyCover' },
      },
    ],
    // eslint-disable-next-line no-nested-ternary
    current: vm.$route.query.b === 'health' ? PersonalDetailsHealth : vm.$route.query.b === 'dp' ? PersonalDetailsDP : vm.$route.query.b === 'dp-ren' ? DPRenewal : PersonalDetails,
    data: {},
  }),
  computed: {
    ...mapGetters('rfq', ['getQoute']),
  },
  mounted() {
    this.$root.$on('nav-back-to', (data) => {
      this.data = { getQuote: this.getQoute };
      this.current = data.currentTab;
    });
    const quote = this.$route.query.q;
    const benefit = this.$route.query.b;
    if (!(!!quote && !!benefit)) {
      this.$toast.error('No Quotation Request Found', 'Quote Error');
      this.$router.push({ name: 'Request' });
    }
    this.$root.$on('qoute-loaded', () => {
      if (this.getQoute.step === 'POLICY_CREATED') {
        this.$toast.warning('Quote is already a policy, view in policies', 'Quotation');
        this.$router.push({ name: 'MyPolicies' });
      } else this.checkStage();
    });
  },
  methods: {
    toCarDetails() {
      this.current = VehicleDetails;
    },
    toCoverSummary() {
      this.current = CoverSummary;
    },
    toBranchSelection() {
      this.current = BranchSelections;
    },
    toPaymentSelection() {
      this.data = { getQuote: this.getQoute };
      this.current = PaymentSelection;
    },
    toMakePayment(data) {
      this.data = data;
      this.current = MakePayment;
    },
    checkStage() {
      const coverType = this.getQoute.covertypes.find((e) => e.riskId === parseInt(this.$route.query.b, 10)) || this.getQoute.covertypes.find((e) => e.recommended === true);
      if ('mainBranchCode' in this.getQoute && this.getQoute.mainBranchCode !== '') {
        this.data = { getQuote: this.getQoute };
        this.current = PaymentSelection;
      } else if ('engineNumber' in coverType.car && coverType.car.engineNumber !== '') {
        this.current = CoverSummary;
      } else if ('coverFrom' in this.getQoute && this.getQoute.coverFrom !== '') {
        this.current = VehicleDetails;
      } else {
        this.current = PersonalDetails;
      }
    },
    checkWindow(vm) {
      if (vm.$route.query.b === 'health') this.current = PersonalDetailsHealth;
      else if (vm.$route.query.b === 'dp') this.current = PersonalDetailsDP;
      else this.current = PersonalDetails;
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
& > * {
    transition-duration: 100ms;
    transition-property: opacity, transform;
    transition-timing-function: cubic-bezier(.6,.15,.35,.8);
  }

}

$delay: 60ms;
$delayStep: 60ms;

.fade-enter,
.fade-leave-to {
& > * {
    opacity: 0;
    transform: translateY(40px);
  }
}
.fade-enter-active {
& > * {
&:nth-child(2) {
   transition-delay: $delay;
 }
&:nth-child(3) {
   transition-delay: $delay + $delayStep;
 }
}
}
.fade-leave-active {
& > * {
&:nth-child(1) {
   transition-delay: $delay + $delayStep;
 }
&:nth-child(2) {
   transition-delay: $delay;
 }
}
}
</style>
